import styles from './WorlLine.module.css'
import WaitLoader from "../../WaitLoader/WaitLoader";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {useRef} from "react";
interface IWorkLineProps
{
    load:boolean
    title?:string
}
export default function WorkLine({load,title}:IWorkLineProps)
{
    const [ldrXlsFile,rsXlsFile,exXlsFile] = useApiQuery("/excel/upload","file",useRef(null));
    return(
        <div className={styles.mainCont}>
            <div className={styles.title}>{title ? title : "Процессинг"}</div>
            <div className={styles.ldrCont}>
                <WaitLoader loading={load} onlyLoading={true} api={rsXlsFile}>

                </WaitLoader>
            </div>
        </div>
    )
}